import { SignedIn, ClerkLoading, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import SyncLoader from "react-spinners/SyncLoader";

// https://github.com/nextauthjs/next-auth/discussions/3550

const AuthChecker = ({ children }: { children: React.ReactNode }) => {
    return (
        <>
            <ClerkLoading>
                <div className="flex justify-center items-center h-screen w-screen ">
                    <SyncLoader
                        color="#000"
                        size={10}
                        aria-label="Loading Spinner"
                        data-testid="loader"

                    />
                </div>
            </ClerkLoading>
            <SignedIn> {children}</SignedIn>
            <SignedOut><RedirectToSignIn /></SignedOut>
        </>
    )
}

export default AuthChecker